export default __webpack_public_path__ + "static/media/img_about-product.2416be96.png";